import { PlaceAutocompleteMatchedSubstring } from 'features/location';

const openTag = '<em>';
const closeTag = '</em>';
const openTagEscaped = escapeHtml(openTag);
const closeTagEscaped = escapeHtml(closeTag);

function escapeHtml(unsafeText: string) {
    if (!unsafeText?.length) {
        return '';
    }

    const text = document.createTextNode(unsafeText);
    const p = document.createElement('p');
    p.appendChild(text);

    return p.innerHTML;
}

function elasticHighlightPartToReplaceOffset(text: string, highlight: string): PlaceAutocompleteMatchedSubstring {
    const highlightWithoutTags = highlight.replace(openTag, '').replace(closeTag, '');
    const textMatchIndex = text.toLowerCase().indexOf(highlightWithoutTags.toLowerCase());

    const openTagIndex = textMatchIndex + highlight.indexOf(openTag);
    const closeTagIndex = textMatchIndex + highlight.indexOf(closeTag) - closeTag.length;

    const isOutOfBounds = openTagIndex < 0 || closeTagIndex > text.length;
    const areBothTagsInHighlight = highlightWithoutTags.length === highlight.length - openTag.length - closeTag.length;

    if (textMatchIndex === -1 || isOutOfBounds || !areBothTagsInHighlight) {
        return { offset: 0, length: 0 };
    }

    return { offset: openTagIndex, length: closeTagIndex - openTagIndex + 1 };
}

export function highlightSearchResult(text: string, highlights: string[] | PlaceAutocompleteMatchedSubstring[]) {
    if (!highlights?.length || !text?.length) {
        return text;
    }

    const matchedSubstrings = hightlightsToCommonFormat(text, highlights);
    const textWithHighlights = insertHighlightTags(text, matchedSubstrings);

    return escapeHtml(textWithHighlights)
        .replaceAll(openTagEscaped, openTag)
        .replaceAll(closeTagEscaped, closeTag);
}

function hightlightsToCommonFormat(text: string, highlights: string[] | PlaceAutocompleteMatchedSubstring[]): PlaceAutocompleteMatchedSubstring[] {
    if (!highlights?.length) {
        return [];
    }

    if (typeof (highlights[0]) === 'string') {
        return (highlights as string[])
            .flatMap(highlight => splitAndKeepDelimiter(highlight, closeTag))
            .map(highlight => elasticHighlightPartToReplaceOffset(text, highlight));
    }

    return highlights as PlaceAutocompleteMatchedSubstring[];
}

function insertHighlightTags(text: string, matchedSubstrings: PlaceAutocompleteMatchedSubstring[]) {
    return matchedSubstrings
        .filter(s => s.offset >= 0 && s.length > 0)
        .sort((a, b) => (a.offset > b.offset ? -1 : 1))
        .reduce((result, matchedSubstring) => insertSubstring(result, matchedSubstring), text);
}

function insertSubstring(text: string, { offset, length }: PlaceAutocompleteMatchedSubstring) {
    return [
        text.slice(0, offset),
        openTag,
        text.slice(offset, offset + length),
        closeTag,
        text.slice(offset + length)
    ].join('');
}

export function isHighlightMachText(text: string, highlight: string) {
    const highlightWithoutTags = highlight.replace(openTag, '').replace(closeTag, '');

    return text.includes(highlightWithoutTags);
}

function splitAndKeepDelimiter(source: string, delimiter: string) {
    const result: string[] = [];
    let replaceStartIndex = 0;

    for (let i = 0; i < source.length; i++) {
        if (source.substring(i, i + delimiter.length) === delimiter) {
            result.push(source.substring(replaceStartIndex, i) + delimiter);
            i += delimiter.length;
            replaceStartIndex = i;
        }
    }

    return result;
}
